import React from 'react'
import BlogPost from './BlogPost'

export default function TwoLanguage() {
  return (
    <BlogPost
      translationKey="twoLanguage"
      seoTitle="Read the World, Feel at Home | Hyunjin Jae"
      seoDescription="A reflection on the benefits of being able to express emotions in Korean and expand your horizons in English."
      seoKeywords="two languages, Korean, English, reflection, personal growth, communication, worldview"
      seoTags={['reflection', 'two languages', 'Korean', 'English', 'personal growth', 'communication', 'worldview']}
    />
  )
} 